import React, { useState, useContext } from 'react';
import { Table } from '@shared/components/ui/Table';
import dayjs from 'dayjs';
import { Loading } from '@shared/components/ui/Loading';
import BasicsContext from '@shared/context/BasicsContext';
import { SubjectTag } from '@shared/components/ui/SubjectTag';

// var relativeTime = require('dayjs/plugin/relativeTime');
// dayjs.extend(relativeTime);

export const TableWaitingSwitchmanRequest = (props) => {
  const { waitingSwitchmanInquiries } = props;

  const basics = useContext(BasicsContext);
  const user = basics ? basics.user : null;
  const [filterUserSubject, setFilterUserSubject] = useState(
    user.role.includes('teacher')
      ? user.subjects.map((subject) => subject.name)
      : null
  );

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: true,
        setCellProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'submitted_at',
      label: 'Soumis le',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => dayjs(value).format('DD/MM/YYYY HH:mm'),
        setCellProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_name',
      label: 'Niveau',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_group',
      label: 'Niveau',
      options: {
        filter: true,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: 'studentInfo',
      label: 'Élève',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'type',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'subject',
      label: 'Matière',
      options: {
        filter: true,
        filterList: filterUserSubject,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => <SubjectTag text={value} />,
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'special',
      label: 'Special',
      options: {
        filter: true,
        sort: true,
        filterType: 'dropdown',
        customFilterListOptions: {
          render: (value) => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          },
        },
        filterOptions: {
          renderValue: value => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value === 1)
            return <SubjectTag text="Documentaliste" />

          if (value === 2)
            return <SubjectTag text="Grand Oral" />

          return "-";
        },
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'preferred_call_time',
      label: "Créneau",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'expiration',
      label: 'Délai',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
  ];

  return (
    <>
      {waitingSwitchmanInquiries ? (
        <Table
          title={`Requêtes en attente d'aiguillage`}
          data={waitingSwitchmanInquiries}
          columns={columns}
          pagination={false}
          setFilterUserSubject={setFilterUserSubject}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

export const TableSwitchmanRequest = (props) => {
  const { switchmanInquiries } = props;

  const basics = useContext(BasicsContext);
  const user = basics ? basics.user : null;
  const subjects = user.role.includes('teacher') ? user.subjects.map((subject) => subject.name) : null;
  const [filterUserSubject, setFilterUserSubject] = useState(subjects);

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: true,
        setCellProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'submitted_at',
      label: 'Soumis le',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => dayjs(value).format('DD/MM/YYYY HH:mm'),
        setCellProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_name',
      label: 'Niveau',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_group',
      label: 'Niveau',
      options: {
        filter: true,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: 'studentInfo',
      label: 'Élève',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'type',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'subject',
      label: 'Matière',
      options: {
        filter: true,
        filterList: filterUserSubject,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => <SubjectTag text={value} />,
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'special',
      label: 'Special',
      options: {
        filter: true,
        sort: true,
        filterType: 'dropdown',
        customFilterListOptions: {
          render: (value) => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          },
        },
        filterOptions: {
          renderValue: value => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value === 1)
            return <SubjectTag text="Documentaliste" />

          if (value === 2)
            return <SubjectTag text="Grand Oral" />

          return "-";
        },
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'switchmanInfo',
      label: 'Aiguilleur',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'preferred_call_time',
      label: "Créneau",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'expiration',
      label: 'Délai',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
  ];

  return (
    <>
      {switchmanInquiries ? (
        <Table
          title={`Requêtes en cours d'aiguillage`}
          data={switchmanInquiries}
          columns={columns}
          pagination={false}
          setFilterUserSubject={setFilterUserSubject}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

export const TableWaitingTeacherRequest = (props) => {
  const { waitingTeacherInquiries } = props;

  const basics = useContext(BasicsContext);
  const user = basics ? basics.user : null;
  const [filterUserSubject, setFilterUserSubject] = useState(
    user.role.includes('teacher') ? user.subjects.map((subject) => subject.name) : null
  );

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: true,
        setCellProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'submitted_at',
      label: 'Soumis le',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => dayjs(value).format('DD/MM/YYYY HH:mm'),
        setCellProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_name',
      label: 'Niveau',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_group',
      label: 'Niveau',
      options: {
        filter: true,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: 'studentInfo',
      label: 'Élève',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'type',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'subject',
      label: 'Matière',
      options: {
        filter: true,
        filterList: filterUserSubject,
        sort: true,
        customBodyRender: (value) => <SubjectTag text={value} />,
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'special',
      label: 'Special',
      options: {
        filter: true,
        sort: true,
        filterType: 'dropdown',
        customFilterListOptions: {
          render: (value) => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          },
        },
        filterOptions: {
          renderValue: value => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          }
        },
        customBodyRender: (value) => {
          if (value === 1)
            return <SubjectTag text="Documentaliste" />

          if (value === 2)
            return <SubjectTag text="Grand Oral" />

          return "-";
        },
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'switchmanInfo',
      label: 'Aiguilleur',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'preferred_call_time',
      label: "Créneau",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'expiration',
      label: 'Délai',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
  ];

  return (
    <>
      {waitingTeacherInquiries ? (
        <Table
          title={`Requêtes en attente de traitement`}
          data={waitingTeacherInquiries}
          columns={columns}
          pagination={false}
          setFilterUserSubject={setFilterUserSubject}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

export const TableTeacherRequest = (props) => {
  const { teacherInquiries } = props;

  const basics = useContext(BasicsContext);
  const user = basics ? basics.user : null;
  const [filterUserSubject, setFilterUserSubject] = useState(
    user.role.includes('teacher') ? user.subjects.map((subject) => subject.name) : null
  );

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: true,
        setCellProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '50px', maxWidth: '50px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'submitted_at',
      label: 'Soumis le',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => dayjs(value).format('DD/MM/YYYY HH:mm'),
        setCellProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '110px', maxWidth: '110px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_name',
      label: 'Niveau',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '90px', maxWidth: '90px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'level_group',
      label: 'Niveau',
      options: {
        filter: true,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: 'studentInfo',
      label: 'Élève',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'type',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '60px', maxWidth: '60px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'subject',
      label: 'Matière',
      options: {
        filter: true,
        filterList: filterUserSubject,
        sort: true,
        customBodyRender: (value) => <SubjectTag text={value} />,
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'special',
      label: 'Special',
      options: {
        filter: true,
        sort: true,
        filterType: 'dropdown',
        customFilterListOptions: {
          render: (value) => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          },
        },
        filterOptions: {
          renderValue: value => {
            if (value === 0) return '-';
            if (value === 1) return "Documentaliste";
            if (value === 2) return "Grand Oral";
          }
        },
        customBodyRender: (value) => {
          if (value === 1)
            return <SubjectTag text="Documentaliste" />

          if (value === 2)
            return <SubjectTag text="Grand Oral" />

          return "-";
        },
        setCellProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '100px', maxWidth: '100px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'switchmanInfo',
      label: 'Aiguilleur',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'teacherInfo',
      label: 'Enseignant',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'preferred_call_time',
      label: "Créneau",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '70px', maxWidth: '70px', padding: '4px 8px' } }),
      },
    },
    {
      name: 'expiration',
      label: 'Délai',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
        setCellHeaderProps: () => ({ style: { minWidth: '120px', maxWidth: '120px', padding: '4px 8px' } }),
      },
    },
  ];

  return (
    <>
      {teacherInquiries ? (
        <Table
          title={`Requêtes en cours de traitement`}
          data={teacherInquiries}
          columns={columns}
          pagination={false}
          setFilterUserSubject={setFilterUserSubject}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};
